<script>
import SpecifyLocation from '@/components/organism/location/SpecifyLocation'

export default {
    name: 'Step1',
    components: {
        SpecifyLocation,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
        loading: Boolean,
    },
    computed: {
        addressValue: {
            get() {
                return this.address
            },
            set(address) {
                this.$emit('change', { ...this.address, ...address })
            },
        },
        loadingComputed: {
            get() {
                return this.loading
            },
            set(value) {
                this.$emit('update:loading', value)
            },
        },
    },
    methods: {
        verifyStep() {
            this.$refs.specifyLocation.verifyStep()
        },
        next() {
            this.$emit('next')
        },
    },
}
</script>

<template lang="pug">
specify-location.h-100(v-model="addressValue" :loading.sync="loadingComputed" @next="next" ref="specifyLocation")      
</template>
